"use strict";

function updateFastFilterActiveState() {
  var params = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-filter-param][data-filter-value]').forEach(function (filter) {
    var filterParam = filter.dataset.filterParam;
    var filterValue = filter.dataset.filterValue;
    if (params.getAll(filterParam).includes(filterValue)) {
      filter.classList.add('is-active');
    } else {
      filter.classList.remove('is-active');
    }
  });
}
document.addEventListener('click', function (event) {
  var fastFilter = event.target.closest('[data-filter-param][data-filter-value]');
  if (!fastFilter) return;
  var filterParam = fastFilter.dataset.filterParam;
  var filterValue = fastFilter.dataset.filterValue;
  document.querySelectorAll("[data-filter-param=\"".concat(filterParam, "\"]")).forEach(function (filter) {
    filter.classList.remove('is-active');
  });
  fastFilter.classList.add('is-active');
  var url = new URL(window.location.href);
  url.searchParams.set(filterParam, filterValue);
  var searchParams = url.searchParams.toString();
  FacetFiltersForm.renderPage(searchParams, null);
});
updateFastFilterActiveState();